import { memo, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Form, FormInput } from 'shards-react';
import { updateFilterByName } from 'utils/redux/actions';

const FilterUsers = ({ dispatch, filterByName = '' }) => {
	const [inputValue, setInputValue] = useState(() => filterByName);

	const changeHandler = useCallback(
		({ target }) => {
			const { value } = target;
			const { valueMissing } = target.validity;

			if (valueMissing) dispatch(updateFilterByName(value));

			return setInputValue(value);
		},
		[dispatch]
	);

	const handleSubmit = useCallback(
		(e) => {
			e.preventDefault();

			dispatch(updateFilterByName(inputValue));
		},
		[inputValue, dispatch]
	);

	return (
		<Form onSubmit={handleSubmit}>
			<FormInput required type='search' spellCheck='false' autoComplete='false' value={inputValue} onChange={changeHandler} placeholder='Nach Benutzername filtern' />
		</Form>
	);
};

const mapStateToProps = ({ filterByName }) => ({ filterByName });

export default connect(mapStateToProps)(memo(FilterUsers));
